import Vue from "vue";
import VueRouter from "vue-router";
import { RouteConfig } from "vue-router/types/router";
import LangRouter from "vue-lang-router";
import translations from "../locales/translations";
import localizedURLs from "../locales/localized-urls";
import store from "@/store";
import Rgpd from "../utils/rgpd";

Vue.use(LangRouter, {
  defaultLanguage: "fr",
  translations,
  localizedURLs,
  i18nOptions: {
    locale: process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    numberFormats: {
      en: {
        percent: {
          style: "percent", useGrouping: false,
        },
        currency: {
          style: "currency",
          currency: "EUR",
          currencyDisplay: "symbol",
        },
        currencyNoCent: {
          style: "currency",
          minimumFractionDigits: 0, maximumFractionDigits: 0,
          currency: "EUR",
          currencyDisplay: "symbol",

        },
      },
      fr: {
        percent: {
          style: "percent", useGrouping: false,
        },
        currency: {
          style: "currency", currency: "EUR", currencyDisplay: "symbol",
        },
        currencyNoCent: {
          style: "currency",
          minimumFractionDigits: 0, maximumFractionDigits: 0,
          currency: "EUR",
          currencyDisplay: "symbol",

        },
      },
    },
    dateTimeFormats: {
      en: {
        short: {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        },
        long: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
      },
      fr: {
        short: {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        },
        long: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
      },
    },
  },
});

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/pages/Home.vue"),
    beforeEnter: requireAuthEmpowermentPages,
  },
  /* {
     path: "/",
     name: "Attente",
     component: () => import("@/pages/Attente.vue"),
     meta: { layout: "attente" },
   },*/
  {
    path: "/categorie/:level1/:level2?/:level3?",
    name: "Category",
    component: () => import("@/pages/Category.vue"),
    beforeEnter: (to, from, next) => {
      function isValid(param) {
        // check if param is valid

        return true;
      }

      if (!isValid(to.params.level1)) {
        next({ name: "Notfound" });
      }
      requireAuthEmpowermentPages(to, from, next);
    },
  },
  {
    path: "/produit/:productSlug",
    name: "Product",
    meta: { layout: "product" },
    component: () => import("@/pages/Product.vue"),
    beforeEnter: requireAuthEmpowermentPages,

  },
  {
    path: "/reinitialisation-mot-de-passe",
    name: "ResetPassword",
    component: () => import("@/pages/ResetPassword.vue"),
  },
  {
    name: "My-account",
    path: "/mon-compte/:pageName?",
    component: () => import("@/pages/MyAccount.vue"),
    beforeEnter: requireAuthEmpowermentPages,
  },
  {
    name: "CheckoutEmpowerment",
    path: "/commande-empowerment",
    meta: { layout: "checkout" },
    component: () => import("@/pages/CheckoutEmpowerment.vue"),
    beforeEnter: requireAuthCheckout,
  },
  {
    path: "/empowerment-sign-in",
    name: "EmpowermentSignIn",
    component: () => import("@/pages/EmpowermentSignIn.vue"),
    beforeEnter: requireAuthEmpowerment,
  },

  {
    path: "/configure-empowerment",
    name: "ConfigureEmpowerment",
    component: () => import("@/pages/ConfigureEmpowerment.vue"),
    beforeEnter: requireAuthConfigureEmpowerment,
  },
  {
    name: "Checkout",
    path: "/commande",
    meta: { layout: "checkout" },
    component: () => import("@/pages/Checkout.vue"),
    redirect: "/commande/livraison",
    beforeEnter: requireAuthCheckout,

    children: [
      {
        path: "connexion",
        name: "CheckoutLogin",
        meta: { layout: "checkout" },
        components: { checkout: () => import("@/pages/Checkout/Login.vue") },
        beforeEnter: requireAuthCheckout,
      },
      {
        path: "livraison",
        name: "CheckoutShipping",
        meta: { layout: "checkout" },
        components: { checkout: () => import("@/pages/Checkout/Shipping.vue") },
        beforeEnter: requireAuthCheckout,
      },

      {
        path: "paiement",
        name: "CheckoutPayment",
        meta: { layout: "checkout" },
        components: { checkout: () => import("@/pages/Checkout/Payment.vue") },
        beforeEnter: requireAuthCheckout,
      },
    ],
  },
  {
    path: "/commande/paiement/resultat",
    name: "CheckoutPaymentResult",
    meta: { layout: "blank" },
    component: () => import("@/pages/Checkout/Payment-Result.vue"),
    beforeEnter: requireAuthCheckout,
  },
  {
    path: "/commande/paiement/attente/:shoppingCartUUID?",
    name: "CheckoutPaymentRetry",
    meta: { layout: "checkout" },
    component: () => import("@/pages/Checkout/Payment-Retry.vue"),
    beforeEnter: requireAuthCheckout,
  },
  {
    path: "/commande/paiement/retour",
    name: "CheckoutPaymentReturn",
    meta: { layout: "blank" },
    component: () => import("@/pages/Checkout/Payment-Return.vue"),
    beforeEnter: requireAuthCheckout,
  },
  {
    path: "/commande/merci/:order?",
    name: "CheckoutThankYou",
    component: () => import("@/pages/Checkout/ThankYou.vue"),
    beforeEnter: requireAuthCheckout,
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/pages/Contact.vue"),
  },
  {
    path: "/recherche",
    name: "Search",
    component: () => import("@/pages/Search.vue"),
    beforeEnter: requireAuthEmpowermentPages,
  },
  {
    path: "/mon-panier",
    name: "Cart",
    component: () => import("@/pages/Cart.vue"),
    beforeEnter: requireAuthEmpowermentPages,
  },
  {
    path: "/mentions-legales",
    name: "LegalMentions",
    component: () => import("@/pages/LegalMentions.vue"),
  },
  {
    path: "/habile-sign-in",
    name: "HabileSignIn",
    component: () => import("@/pages/HabileSignIn.vue"),
    beforeEnter: requireAuthHabile,
  },
  {
    path: "/conditions-generales-de-vente",
    name: "TermsOfUse",
    component: () => import("@/pages/TermsOfUse.vue"),
  },
  {
    path: "/faq",
    name: "Faq",
    component: () => import("@/pages/Faq.vue"),
  },
  {
    path: "/gestion-des-cookies",
    name: "Cookies",
    component: () => import("@/pages/Cookies.vue"),
  },
  {
    path: "/politique-de-protection-des-donnees-personnelles",
    name: "Rgpd",
    component: () => import("@/pages/Rgpd.vue"),
  },
  {
    path: "/livraison",
    name: "Livraison",
    component: () => import("@/pages/Delivery.vue"),
  },
  {
    path: "/echange-retour",
    name: "Echange et retour",
    component: () => import("@/pages/ExchangeAndReturn.vue"),
  },
  {
    path: "/404",
    name: "Notfound",
    meta: { title: "not found", decription: { "content": "not found" } },
    component: () => import("@/pages/NotFound.vue"),
  },
  {
    path: "/401",
    name: "Notauthorized",
    component: () => import("@/pages/NotAuthorized.vue"),
  },
  /* {
     path: "/en/*",
     redirect: "/",
   },
   {
     path: "/en",
     redirect: "/",
   },*/
  {
    path: "*",
    redirect: "/404",
  },

];

const router = new LangRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    //&& to.name != "category"
    Rgpd.initRgpd();
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        behaviors: "smooth",
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

function requireAuthHabile(to, from, next) {
  if (to.query.code) {
    next();
  } else {
    router.push("/401").catch();
  }
}

function requireAuthEmpowerment(to, from, next) {

  if (to.query.context && to.query.client) {
    next();
  } else {
    router.push("/401").catch();
  }
}

function requireAuthCheckout(to, from, next) {

  function proceed() {

    if (store.getters.getCart != null) {
      const cart = store.getters.getCart;
      if (cart && cart.cartItems.length > 0) {
        if (store.getters.getProfile !== null) {
        
          if (store.getters.getProfile.customerGroup === "Empowerment") {
            if (to.name !== "CheckoutEmpowerment") {
              router.push(router.app.$localizePath("/commande-empowerment")).catch();
            }
            next();
          }
          next();
        } else {
          if (from.name !== "CheckoutLogin" && to.name !== "CheckoutLogin") {
            //store.dispatch("toggleLoginModal", { open: true }).then();
            if (sessionStorage.getItem("empowerment")) {
              const url = process.env.VUE_APP_HABILE_HTTP_VERSION + "://" + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + "authorization.oauth2?client_id=" + process.env.VUE_APP_HABILE_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_HABILE_REDIRECT_URI + "&response_type=code&scope=openid email";
              window.location.href = url;
            } else {
              router.push(router.app.$localizePath("/commande/connexion")).catch();
              return;
            }
          } else {
            if (to.name != "CheckoutLogin") {
              return;
            } else {
              next();
            }
          }
        }

      }
    } else {
      if (to.name != "Cart") {
        router.push(router.app.$localizePath("/mon-panier")).catch();
      }
    }
  }

  if (!store.getters.getProfile || !store.getters.getCart) {
    store.dispatch("getCart").then((cart) => {
      store.dispatch("getMe").then(proceed);
    });
  } else {
    proceed();
  }
}

function requireAuthConfigureEmpowerment(to, from, next) {

  function proceed() {

    if (store.getters.getProfile !== null) {
      if (store.getters.getProfile.customerGroup === "Air France employee") {
        next();
        return;
      } else {
        if (sessionStorage.getItem("empowerment")) {
          const url = process.env.VUE_APP_HABILE_HTTP_VERSION + "://" + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + "authorization.oauth2?client_id=" + process.env.VUE_APP_HABILE_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_HABILE_REDIRECT_URI + "&response_type=code&scope=openid email";
          window.location.href = url;
          return;
        } else {
          router.push(router.app.$localizePath("/401")).catch();
          return;
        }
      }

    } else {
      //store.dispatch("toggleLoginModal", { open: true }).then();
      router.push(router.app.$localizePath("/401")).catch();
      return;
    }
  }

  if (!store.getters.getProfile) {
    store.dispatch("getMe").then(proceed);

  } else {
    proceed();
  }
}

function requireAuthEmpowermentPages(to, from, next) {

  function proceed() {
    if (sessionStorage.getItem("empowerment")) {
      if (store.getters.getProfile !== null) {
        if (store.getters.getProfile.customerGroup === "Empowerment") {
          next();
          return;
        } else {
          const url = process.env.VUE_APP_HABILE_HTTP_VERSION + "://" + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + "authorization.oauth2?client_id=" + process.env.VUE_APP_HABILE_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_HABILE_REDIRECT_URI + "&response_type=code&scope=openid email";
          window.location.href = url;
          return;
        }
      } else {
        //store.dispatch("toggleLoginModal", { open: true }).then();
        const url = process.env.VUE_APP_HABILE_HTTP_VERSION + "://" + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + "authorization.oauth2?client_id=" + process.env.VUE_APP_HABILE_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_HABILE_REDIRECT_URI + "&response_type=code&scope=openid email";
        window.location.href = url;
        return;
      }
    } else {
      next();
      return;
    }
  }

  if (!store.getters.getProfile) {
    store.dispatch("getMe").then(proceed);
  } else {
    proceed();
  }
}

export default router;
